var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2763_6658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.696777 13.5208L1.95297 15.658L3.17529 14.9284V35.6568H0.696777V38.1354H10.6935V15.8287H33.0001V30.6998H40.5183V14.9284L41.7406 15.658L42.9968 13.5208L21.8468 0.875L0.696777 13.5208ZM28.0431 13.3502H15.6505V10.8717H28.0431V13.3502Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.172 38.1357H23.0861V30.7002H30.5216V28.2217H13.172V38.1357Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.172 18.3076H30.5216V20.7861H13.172V18.3076Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.172 23.2646H30.5216V25.7432H13.172V23.2646Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5646 33.1787H42.9968V43.1754H25.5646V33.1787Z",
    fill: "#57B8EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2763_6658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3,
    height: 42.3,
    fill: "white",
    transform: "translate(0.696777 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.8729ae169a3f0189269c5a638b852388.svg";
export { ForwardRef as ReactComponent };